export const PLACEMENTS = {
  top: 'top',
  left: 'left',
  right: 'right',
  bottom: 'bottom',
};

export const TYPES = {
  solid: 'solid',
  float: 'float',
};

export const SIZES = {
  medium: 'medium',
  large: 'large',
};

export const TEXT_LENGTH = {
  small: 50,
  medium: 125,
};
